module.exports = __webpack_public_path__ + "static/media/full-kyc.735981fd.png";